(() => {
  if (window.__msHeaderLifecycle) return;
  window.__msHeaderLifecycle = true;
  const initialize = (scope = document) => {
    const headers = [...(scope.matches?.('[data-ms-header]') ? [scope] : []), ...scope.querySelectorAll('[data-ms-header]')];
    headers.forEach(header => {
      if (header.dataset.initialized) return;
      header.dataset.initialized = 'true';
      const section = header.closest('.section-header');
      const toggle = header.querySelector('[data-menu-toggle]');
      const panel = header.querySelector('[data-menu-panel]');
      const close = header.querySelector('[data-menu-close]');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const inerted = new Map();
      let anchor = Math.max(0, window.scrollY), scheduled = false;
      const reveal = () => section.classList.remove('is-header-hidden');
      const syncCompact = () => {
        const desktop = window.matchMedia('(min-width:990px)').matches;
        const compact = header.classList.contains('is-compact');
        header.classList.toggle('is-compact', desktop && header.classList.contains('site-header--sticky') && window.scrollY > (compact ? 64 : 120));
      };
      syncCompact();
      const setBackgroundInert = active => {
        if (active && !inerted.size) {
          const dialog = document.querySelector('[data-ms-inquiry-dialog]');
          const dialogBranch = dialog && [...document.body.children].find(child => child.contains(dialog));
          [...document.body.children].forEach(child => {
            if (child === section || child === dialogBranch) return;
            inerted.set(child, child.inert);
            child.inert = true;
          });
        } else {
          inerted.forEach((wasInert, child) => { if (child.isConnected) child.inert = wasInert; });
          inerted.clear();
        }
      };
      const closeMenu = (restore = true) => {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        setBackgroundInert(false);
        document.body.classList.remove('ms-menu-open');
        if (restore) toggle.focus({ preventScroll: true });
      };
      toggle.addEventListener('click', () => {
        reveal(); panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        setBackgroundInert(true);
        document.body.classList.add('ms-menu-open');
        close.focus();
      }, options);
      close.addEventListener('click', () => closeMenu(), options);
      panel.addEventListener('click', event => { if (event.target === panel) closeMenu(); }, options);
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          if (!panel.hidden) { event.preventDefault(); closeMenu(); return; }
          const disclosure = event.target.closest('details[open]');
          if (disclosure) { disclosure.open = false; disclosure.querySelector('summary').focus(); }
        }
        if (event.key !== 'Tab' || panel.hidden) return;
        const items = [...panel.querySelectorAll('a[href],button,summary')].filter(el => el.getClientRects().length);
        const first = items[0], last = items.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, options);
      header.addEventListener('toggle', event => {
        if (!(event.target instanceof HTMLDetailsElement) || !event.target.open) return;
        reveal();
        header.querySelectorAll('details[open]').forEach(other => {
          if (other !== event.target && !other.contains(event.target)) other.open = false;
        });
      }, { ...options, capture: true });
      document.addEventListener('click', event => {
        header.querySelectorAll('details[open]').forEach(details => {
          if (!details.contains(event.target)) details.open = false;
        });
      }, options);
      header.addEventListener('focusin', reveal, options);
      const update = () => {
        scheduled = false;
        if (!header.isConnected) { closeMenu(false); controller.abort(); return; }
        syncCompact();
        const y = Math.max(0, window.scrollY);
        if (y < section.offsetHeight || !panel.hidden || header.querySelector('details[open]') || header.contains(document.activeElement)) {
          reveal(); anchor = y; return;
        }
        if (Math.abs(y - anchor) < 12) return;
        section.classList.toggle('is-header-hidden', header.classList.contains('site-header--sticky') && y > anchor);
        anchor = y;
      };
      window.addEventListener('scroll', () => {
        if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
      }, { ...options, passive: true });
      const media = matchMedia('(min-width:990px)');
      media.addEventListener('change', () => { if (media.matches) closeMenu(false); syncCompact(); reveal(); }, options);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target === section || event.target.contains?.(section)) { closeMenu(false); delete header.dataset.initialized; controller.abort(); }
      }, options);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

